import type { DataTableColumn } from "@carbon6/c6-frontend-design";
import { StatusChip } from "@/shared/ui/status";
import { formatDateTime } from "@/shared/utils/datetime/format";
import { shortDigest } from "../feature/datasetFormatters";
import { probeStatusView } from "../feature/probeStatus";
import type { ProbeTableRow } from "./ProbeTableRow";

/**
 * Probe 이력의 컬럼.
 *
 * 서버가 이미 최신순으로 주므로 초기 정렬을 따로 세우지 않는다. 사용자가 컬럼을 눌러 다른 순서로
 * 볼 수는 있다.
 */
export const probeColumns: readonly DataTableColumn<ProbeTableRow>[] = [
  {
    key: "state",
    header: "상태",
    width: "9rem",
    sortable: "both",
    render: (row) => {
      const view = probeStatusView(row.state);
      return <StatusChip tone={view.tone}>{view.label}</StatusChip>;
    },
  },
  {
    key: "createdAtMs",
    header: "요청 시각",
    width: "11rem",
    sortable: "both",
    render: (row) => formatDateTime(row.createdAtMs),
  },
  {
    key: "episodeTarget",
    header: "요청 episode",
    width: "8rem",
    align: "right",
    sortable: "both",
    render: (row) => `${row.episodeTarget}개`,
  },
  {
    key: "selectedCount",
    header: "선택 episode",
    width: "8rem",
    align: "right",
    sortable: "both",
    // null(아직 고르지 않음)과 0(고른 것이 없음)은 다른 뜻이라 표기를 가른다.
    render: (row) => (row.selectedCount === null ? "—" : `${row.selectedCount}개`),
  },
  {
    key: "revisionIdentifier",
    header: "Revision",
    width: "minmax(9rem, 1fr)",
    sortable: "both",
    render: (row) => (row.revisionIdentifier === "" ? "—" : shortDigest(row.revisionIdentifier)),
  },
];
